var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"aside-status",class:_vm.status},[_c('BaseIcon',{attrs:{"valign":"baseline","glyph":_vm.glyph}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }